export const LabelProp = Object.freeze({
    Shape: 'shape',
    Text: 'text',
    TextColor: 'textColor',
    BackgroundColor: 'backgroundColor',
    PopupInfo: 'popupInfo',
    Size: 'size',
    CornerLocation: 'cornerLocation',
});